var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Default notes"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.00008 5.83333H13.0001M8.00008 9.16667H13.0001M8.00008 12.5H11.3334M4.66675 4.16667C4.66675 3.72464 4.84234 3.30072 5.1549 2.98816C5.46746 2.67559 5.89139 2.5 6.33341 2.5H14.6667C15.1088 2.5 15.5327 2.67559 15.8453 2.98816C16.1578 3.30072 16.3334 3.72464 16.3334 4.16667V15.8333C16.3334 16.2754 16.1578 16.6993 15.8453 17.0118C15.5327 17.3244 15.1088 17.5 14.6667 17.5H6.33341C5.89139 17.5 5.46746 17.3244 5.1549 17.0118C4.84234 16.6993 4.66675 16.2754 4.66675 15.8333V4.16667Z",
    stroke: "#9599A0",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotes);
export default __webpack_public_path__ + "static/media/notes.8a52217e623399d33761d76a5cf744c9.svg";
export { ForwardRef as ReactComponent };